/* eslint-disable no-nested-ternary */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

// eslint-disable-next-line import/extensions
import * as overlayActions from './overlayActions.js';
import * as appActions from '../../appActions';
import './overlayStyle.less';
import './scrollLock.less';

class OverlayFull extends Component {
  constructor() {
    super();
    this.state = { top: '' };
  }

 componentDidMount() {
    this.setTop();
    window.addEventListener('load', this.setTop);
    window.addEventListener('resize', this.resize);
  }

  componentWillUnmount() {
    window.removeEventListener('load', this.setTop);
    window.removeEventListener('resize', this.resize);
  }

  setTop = () => {
    const overlayElem = document.getElementById('pdp-cart-overlay');
    if (overlayElem && window.innerWidth >= 1000) {
      this.setState({ top: `${document.getElementById('fixed_header').clientHeight}px` });
    }
  }

  resize = () => {
    if (window.innerWidth >= 1000) {
      setTimeout(() => {
        this.setTop();
      }, 1000);
    }
  }

  stopPropagation(e) {
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();
  }

  render() {
    const {
      type,
      show,
      content,
      combineAndSaveOffers,
    } = this.props;
    // fallback class for when there is no offers for the thing
    const className =
      type === 'double' && combineAndSaveOffers.length > 0
        ? type
        : type !== 'double'
          ? type
          : '';
    return (
      <div className={show ? 'overlayWrapper w-active' : 'overlayWrapper'}>
        <div
          id="pdp-cart-overlay"
          // style={{ top: this.state.top }}
          className={show ? 'h-overlay active' : 'h-overlay'}
          onClick={() => this.props.CLOSE_OVERLAY()}
        />
        <div
          className={`${!this.props.app.isCustomizationOpen && className} d-overlay`}
          style={
            {
              top: this.state.top,
              height: this.state.top === '0px' ? null : `calc(100vh - ${this.state.top})`,
              display: show ? null : 'none',
            }
          }
        >
          {show && (
            <div className="overlayFull" id="overlay">
              <div
                className="overlayContentholder"
                onClick={() => this.stopPropagation}
              >
                {content}
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ overlayFull, offers, app }) => {
  return {
    app,
    type: overlayFull.type,
    show: overlayFull.show,
    content: overlayFull.content,
    combineAndSaveOffers: offers.combineAndSaveOffers,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      ...appActions, ...overlayActions,
    },
    dispatch,
  );
};
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(OverlayFull);
